import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

const { locally } = publicRuntimeConfig;

interface Props {
  className?: string;
  upc: string;
}
const LocallyDropdown = ({ className, upc }: Props) => {
  const { geo } = useCurrentUrl();
  const { t } = useTranslation();
  const lang = geo?.locale.toLowerCase();

  const generateConfig = () => ({
    company_name: locally?.companyName,
    button_text: t('productDetailPageContent.locallyButtonText', undefined, {
      default: 'Shop Local',
    }),
    button_id: 'HTML',
    company_id: locally?.companyId,
    css: '5',
    button_toggles_all: '1',
    upc,
    show_location_switcher: '1',
    show_location_prompt: '1',
    lang,
    show_dealers: '1',
    n_dealers: '3',
    show_dealer_count: '1',
    show_address: '1',
    show_phone: '1',
    link_opens_modal: '1',
  });

  const generateUrl = (config: any) => {
    return new URLSearchParams(
      Object.entries(config).map(([key, value]) => [
        key,
        typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value),
      ]),
    );
  };

  const injectScript = (src: string) => {
    const existingScript = document.getElementById('lcly-script');
    existingScript?.remove();

    const script = document.createElement('script');
    script.id = 'lcly-script';
    script.src = src;
    script.async = true;
    document.body.appendChild(script);
  };

  React.useEffect(() => {
    const config = generateConfig();
    const url = generateUrl(config);
    injectScript(`https://traeger-grill.locally.com/stores/map.js?${url}`);
  }, [upc]);

  return (
    <div className={className}>
      <div
        id="lcly-button-0"
        data-switchlive="true"
        data-switchlive-impression="true"
        data-switchlive-impression-id-PL="1"
        className={className}
      >
        <a
          id="lcly-link-0"
          data-switchlive="true"
          data-switchlive-mode="auto"
          data-switchlive-id-PL="6"
          role="button"
          href="https://join.locally.com/for-brands"
          target="_blank"
        >
          Product Locator by Locally
        </a>
      </div>
    </div>
  );
};

export default LocallyDropdown;
